import { type YDatabase } from '@databases/collab/y-database';

/**
 * This migration syncs `view.sort` to `view.sorts` in order to preserve the "sort by" field and
 * direction of a user's views after updating the experience from only allowing sorting by a
 * single field to allowing sorting by multiple fields
 */
export const sortToMultiSort = {
  version: 1745551331585, // Timestamp of the migration when it's written
  apply(_documentId: string, ydb: YDatabase) {
    for (const viewId of ydb.views) {
      const view = ydb.viewsById[viewId];
      if (view) {
        view.initializeSorts();
        view.sorts.clearAll();
        if (view.sort) {
          view.sorts.appendSort(view.sort);
        }
      }
    }
  }
};
